import React from "react";
import { Save, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Switch } from "../ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export function NotificationsTab({ notifications, setNotifications, saving, onSave }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Notification Preferences</CardTitle>
        <CardDescription>Configure how and when you receive notifications</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div>
          <h3 className="font-medium mb-4">Email Notifications</h3>
          <div className="space-y-4">
            <NotifRow label="Renewal Reminders" desc="Get notified before contract renewals" checked={notifications.emailRenewals} onChange={(c) => setNotifications({ ...notifications, emailRenewals: c })} testId="email-renewals-switch" />
            <NotifRow label="Approval Requests" desc="Get notified when you have pending approvals" checked={notifications.emailApprovals} onChange={(c) => setNotifications({ ...notifications, emailApprovals: c })} testId="email-approvals-switch" />
            <NotifRow label="Expiration Alerts" desc="Get notified before contracts expire" checked={notifications.emailExpiration} onChange={(c) => setNotifications({ ...notifications, emailExpiration: c })} testId="email-expiration-switch" />
          </div>
        </div>

        <div>
          <h3 className="font-medium mb-4">In-App Notifications</h3>
          <div className="space-y-4">
            <NotifRow label="Renewal Reminders" desc="Show in dashboard notifications" checked={notifications.inAppRenewals} onChange={(c) => setNotifications({ ...notifications, inAppRenewals: c })} testId="inapp-renewals-switch" />
            <NotifRow label="Approval Requests" desc="Show in dashboard notifications" checked={notifications.inAppApprovals} onChange={(c) => setNotifications({ ...notifications, inAppApprovals: c })} testId="inapp-approvals-switch" />
          </div>
        </div>

        <div>
          <h3 className="font-medium mb-4">Reminder Timing</h3>
          <div className="max-w-xs space-y-2">
            <Label className="text-xs font-mono uppercase tracking-wider text-slate-500">Days before expiration</Label>
            <Select value={notifications.reminderDays} onValueChange={(value) => setNotifications({ ...notifications, reminderDays: value })}>
              <SelectTrigger className="rounded-sm" data-testid="reminder-days-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="7">7 days</SelectItem>
                <SelectItem value="14">14 days</SelectItem>
                <SelectItem value="30">30 days</SelectItem>
                <SelectItem value="60">60 days</SelectItem>
                <SelectItem value="90">90 days</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>

        <div className="flex justify-end">
          <Button onClick={onSave} disabled={saving} className="gap-2 rounded-sm" data-testid="save-notifications-btn">
            {saving ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} />} Save Preferences
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}

function NotifRow({ label, desc, checked, onChange, testId }) {
  return (
    <div className="flex items-center justify-between p-4 border rounded-sm">
      <div>
        <p className="font-medium">{label}</p>
        <p className="text-sm text-slate-500">{desc}</p>
      </div>
      <Switch checked={checked} onCheckedChange={onChange} data-testid={testId} />
    </div>
  );
}
